import { binaryPackageReducer, combineReducers } from "../shared";
import {
  SET_ACTIVE_RATE_PLAN,
  SET_ACTIVE_TOAST_MESSAGES,
  SET_GENERAL_SETTINGS_FORM,
  SET_BILLING_SETTINGS_FORM,
  SET_MESSAGING_SETTINGS_FORM,
  SET_PASSES_SETTINGS_FORM,
  POPULATE_PASS_OFFERS,
  POPULATE_PASS_OFFERS_COUNT,
  POPULATE_PASS_OFFER_TYPES,
  SET_SETTINGS_INVALIDS,
  SET_SORT_BY,
  SET_ORDER_BY,
  SET_PAGE_NUMBER,
  SET_ROWS_PER_PAGE,
  SET_HIDE_DISABLED,
  POPULATE_MARKETS,
  POPULATE_FINE_TYPES,
} from "../types";

const fleetSettingsReducer = (state, action) => {
  switch (action.type) {
    case SET_ACTIVE_RATE_PLAN:
      return {
        ...state,
        activeRatePlan: action.payload,
      };
    case SET_ACTIVE_TOAST_MESSAGES:
      return {
        ...state,
        activeToastMessages: action.payload,
      };
    case POPULATE_PASS_OFFERS:
      return {
        ...state,
        passOffers: action.payload,
      };
    case POPULATE_PASS_OFFERS_COUNT:
      return {
        ...state,
        passOffersCount: action.payload,
      };
    case POPULATE_PASS_OFFER_TYPES:
      return {
        ...state,
        passOfferTypes: action.payload,
      };
    case SET_GENERAL_SETTINGS_FORM:
      return {
        ...state,
        general: action.payload,
      };
    case SET_BILLING_SETTINGS_FORM:
      return {
        ...state,
        billing: action.payload,
      };
    case SET_MESSAGING_SETTINGS_FORM:
      return {
        ...state,
        messaging: action.payload,
      };
    case SET_PASSES_SETTINGS_FORM:
      return {
        ...state,
        passes: action.payload,
      };
    case SET_SETTINGS_INVALIDS:
      return {
        ...state,
        invalids: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderBy: action.payload,
      };
    case SET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.payload,
      };
    case SET_HIDE_DISABLED:
      return {
        ...state,
        hideDisabled: action.payload,
      };
    case POPULATE_MARKETS:
      return {
        ...state,
        markets: action.payload,
      };
    case POPULATE_FINE_TYPES:
      return {
        ...state,
        fineTypes: action.payload,
      };
    default:
      return state;
  }
};

export default combineReducers(fleetSettingsReducer, binaryPackageReducer);
